import { cn } from '../../style-system';
import { CurrencyCode, formatPrice } from '../../utils';

type CompactPriceProps = {
    price?: number;
    className?: string;
    currency?: CurrencyCode;
    fractionDigits?: number;
};

const CompactPrice = ({ fractionDigits, className, price, currency }: CompactPriceProps) => {
    if (!price) {
        return null;
    }

    return <span className={cn(className)}>${formatPrice(price, fractionDigits, currency)}</span>;
};

export type { CompactPriceProps };
export { CompactPrice };
